/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/**
 * If you use  this plugin, make sure to  first include require('intersection-observer'); on your page
 */
(function ($) {
  $.fn.observe = function (callback = () => false, options = {}) {
    // eslint-disable-next-line prefer-arrow-callback
    return this.each(function () {
      const settings = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
        ...options,
      };

      const observer = new IntersectionObserver(callback, settings);

      observer.observe($(this)[0]);

      return this;
    });
  };
})(jQuery);
